import { type SelectOption } from '@factorialco/deprecated-design-system'

import FormRow from 'modules/core/components/FormRow'
import Select from 'modules/core/components/Inputs/Select'
import 'modules/core/components/Inputs/types'
import i18n from 'modules/core/lib/i18n'

type PayrollDays = 'on_day_of_month' | 'last_day_of_month' | 'on_day_of_next_month'

interface PaymentDayOption {
  key: number | 'last_day_of_month'
  value: PayrollDays
}

// Generate available values for payroll payment days options
const generatePayrollPaymentDays = (): Array<PaymentDayOption> => {
  const currentMonth = Array.from(
    {
      length: 11,
    },
    (_a, i) => [20 + i, 'on_day_of_month'] as const
  )

  const nextMonth = Array.from(
    {
      length: 5,
    },
    (_a, i) => [1 + i, 'on_day_of_next_month'] as const
  )

  const all = [...currentMonth, ['last_day_of_month', 'last_day_of_month'] as const, ...nextMonth]

  return all.map(([key, value]) => ({
    key,
    value,
  }))
}

const getPaymentLabel = (option: PaymentDayOption): string => {
  const params = { day: option.key }

  switch (option.value) {
    case 'on_day_of_month':
      return i18n.t('settings.customizations.payroll.payment_date.on_day_of_month', params)
    case 'last_day_of_month':
      return i18n.t('settings.customizations.payroll.payment_date.last_day_of_month')
    case 'on_day_of_next_month':
      return i18n.t('settings.customizations.payroll.payment_date.on_day_of_next_month', params)
    default:
      throw new Error(`Unknown payroll payment day: ${option.value}`)
  }
}

const paymentDateOptions = (): SelectOption[] =>
  generatePayrollPaymentDays().map((option) => {
    return {
      value: option.key,
      label: getPaymentLabel(option),
    }
  })

interface SelectProps {
  paymentDate: string
}

const PaymentDateSelect = ({ paymentDate }: SelectProps) => (
  <FormRow>
    <Select
      mandatory
      label={i18n.t('settings.customizations.payroll.payment_date.label')}
      field={paymentDate as any}
      options={paymentDateOptions()}
    />
  </FormRow>
)

export default PaymentDateSelect
